module.exports = __webpack_public_path__ + "img/Avatar-36.16fade4f.svg";